/**
 * Logo Component
 * 
 * Full MyVitae logo with icon and text.
 * Uses brand configuration for colors and domain name.
 * 
 * Usage:
 *   import { Logo } from '../design-system/brand';
 *   <Logo iconSize="w-8 h-8" textSize="text-2xl" />
 */
import React from "react";
import LogoIcon from "./LogoIcon";
import { brand } from "./brandConfig";
import { brandColors } from "../tokens";
import { logoFontStyle } from "./logoFont";

const Logo = ({ 
  iconSize = "w-8 h-8", 
  textSize = "text-2xl", 
  iconColor = "#60a5fa",
  textColor = brandColors.primary,
  useCurrentColor = false,
  className = "flex items-center space-x-1"
}) => {
  // When using currentColor for the icon, we must apply the intended color
  // to the wrapper so the SVG inherits it (otherwise it defaults to black).
  const wrapperClassName = useCurrentColor ? `${className} ${textColor}` : className;

  return (
    <div className={wrapperClassName}>
      {/* Logo Icon on the left */}
      <LogoIcon className={iconSize} color={iconColor} useCurrentColor={useCurrentColor} />
      
      {/* myvitae.ai text on the right */}
      <span className={`${textSize} font-bold ${textColor}`} style={logoFontStyle}>
        {brand.identity.domain}<sup className="text-sm">®</sup>
      </span>
    </div>
  );
};

export default Logo;
